<template>
    <div class="payment">
        <el-card shadow = "never">
            <el-row>
                <el-col :span="14" :offset="1">
                    <el-form
                    :model="ruleForm" 
                    :rules="rules" 
                    ref="ruleForm"
                    label-width="80px"
                    class="demo-ruleForm"
                    >
                        <el-form-item label="销售地点" prop="locationCode">
                            <el-select v-model="value" filterable placeholder="试一试搜索:销售地点" :clearable = 'clearable' @change="handleChange2" size = "large" style="width : 350px" :disabled = "disabled">
                                <i class="el-icon-loading" slot = "prefix" v-if='isLoading'></i>
                                <el-option
                                    v-for="item in options2"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label ="日期" prop="date">
                            <el-date-picker
                                v-model="ruleForm.date"
                                type="daterange"
                                range-separator="至"
                                placeholder="选择日期"
                                value-format = "yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :default-value = "defaultVal"
                                >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
                            <el-button @click="cancel">返回</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-table
                        max-height="340"
                        :data = "tableData"
                        border
                        style="width:100%"
                        v-loading="loading"
                        :summary-method="getSummaries"  
                        show-summary
                    >
                        <!-- <el-table-column
                            prop="date"
                            label="日期"
                            align="left"
                            header-align="center"
                            >
                        </el-table-column> -->
                        <el-table-column
                            prop="addr"
                            label="地点"
                            align="left"
                            header-align="center"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="totalCount"
                            label="订单数量"
                            align="right"
                            width="120"
                            header-align="center"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="totalAmounnt"
                            label="销售数量"
                            align="right"
                            width="120"
                            header-align="center"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="totalPrice"
                            label="销售金额"
                            align="right"
                            width="120"
                            header-align="center"
                            >
                        </el-table-column>
                        <el-table-column
                            label="支付方式"
                            header-align="center"
                            align="right"
                            prop="payInfo"
                        >
                            <template slot-scope="scope">
                                <el-row v-for="item in scope.row.payInfo">
                                    <el-col :span="9" :offset="5" class="textLeft">
                                        <p>{{item.desc}}:{{item.totalPrice}}</p>
                                    </el-col>
                                    <el-col :span="9">
                                        <p>订单数量:{{item.totalCount}}</p>
                                    </el-col>
                                </el-row>
                                <!-- <el-row>
                                    <el-col :span="9" :offset="5" class="textLeft">
                                        <p>微信 :</p>
                                    </el-col>
                                    <el-col :span="9">
                                        <p>{{scope.row.wechat}}</p>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="9" :offset="5">
                                        <p class="textLeft">银联 :</p>
                                    </el-col>
                                    <el-col :span="9">
                                        <p>{{scope.row.unipay}}</p>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="9" :offset="5">
                                        <p class="textLeft">信用卡 :</p>
                                    </el-col>
                                    <el-col :span="9">
                                        <p>{{scope.row.credit}}</p>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="9" :offset="5">
                                        <p class="textLeft">现金 :</p>
                                    </el-col>
                                    <el-col :span="9">
                                        <p>{{scope.row.cash}}</p>
                                    </el-col>
                                </el-row> -->
                            </template>
                        </el-table-column>
                    </el-table>

                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less">
    .textLeft{
        text-align: left ;
    }
</style>
<script>
import requestMixin from '@/mixins/request'
import common from '@/mixins/common'
import axios from '@/env/axios'
import apis from '@/env/apis'
import { filterParams } from '@/env/util'
export default {
    mixins:[requestMixin,common],
    data(){
        return {
            ruleForm:{
                locationCode:'',
                // date : [new Date(new Date().setHours(0,0,0,0))],
                date : [],
            },
           defaultVal :[],
            rules:{
                // locationCode: [
                //     { required: true, message: '地点名称还未加载', trigger: 'blur' },
                // ], 
                // date: [
                //     { required: true, message: '请选择时间', trigger: 'blur' },
                // ]
            },
            options2:[
                {
                    value : '', 
                    label : ''
                }
            ],
            value: '',
            locationDes:"",
            labelPosition: 'right',
            formLabelAlign: {
                qty:"",
                amt: '',
                ali: '',
                wechat: '',
                unipay: '',
                credit: '',
                cash: ''
            },
            tableData:[
                // {
                //     qty:"",
                //     amt: '',
                //     ali: '',
                //     wechat: '',
                //     unipay: '',
                //     credit: '',
                //     cash: ''
                // }
            ],
            isLoading:true,
            clearable : false,
            disabled : true ,
            loading:false
        }
         
    },
    created (){
       
    },
    mounted(){
        this.loadingArea().then((res) => {
            this.options2 = res ;
            this.getLoc()
        }); 
        this.defaultNow();
        
    },
    methods:{
        submitForm(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let { locationCode:location, date } = this.ruleForm ;
                    let userId = sessionStorage.getItem("userId") ;
                    // console.log(this.ruleForm)
                    let ruleForm2 = {
                        location:location,
                        from:date?date[0]:'',
                        to:date?date[1] : '',
                        userId
                    };
                    // let params ;
                    this.tableData = [] ;
                    this.loading = true;
                    // if(date == null && location == '' || date == '' && location == ''){
                    //     params = {
                    //         act : "orderByAddr"
                    //     }
                    // }else if(date == null && location || date == '' && location){
                    //     params = {
                    //         act : "orderByAddr",
                    //         location
                    //     }
                    // }else if(date && location == ''){
                    //     params = {
                    //         act : "orderByAddr",
                    //         from : date[0],
                    //         to : date[1]
                    //     }
                    // }
                    // else{
                    //     params = {
                    //         act : "orderByAddr",
                    //         from : date[0],
                    //         to : date[1],
                    //         location
                    //     }
                    // }
                    let act = "orderByAddr";
                    let params = filterParams(ruleForm2,act)
                    // console.log(params)
                    this.getReports( params );
                } else {
                    return false;
                }
            });
        },
        //点击取消，跳转到上一页
        cancel(){
            this.$router.go(-1)
        },
        handleChange2(value){
            this.ruleForm.locationCode = value ;
            this.tableData = [];
        },
        //默认显示用户地点/获取地点编号
        getLoc(){
            this.getUserLocation().then((res) => {
                let userId = sessionStorage.getItem("userId") ;
                this.value = res ;
                if(this.options2.length > 0){
                    this.ruleForm.locationCode = res;
                    this.isTrueAccount(userId);
                    this.isLoading = false ;
                }
            })
        },


        //请求结算报表
        getReports(params){
            let that = this;
            that.delType(params).then((res) =>{
                // console.log(res)
                let { code ,data } = res.data;
                if(code == 200){
                    that.loading = false;
                    that.tableData = data;
                }else{
                     that.loading = false;
                    that.alert('查找失败!','warning')
                }
                // if(status == true){
                //     this.formLabelAlign = report;
                //     let locationDes = `${params.from} ~ ${params.to}`;
                //     let location = `${params.location}` ;
                //     if(locationDes == '2000-01-01 ~ 3000-01-01'){
                //         report.date = ''
                //     }else{
                //         report.date =`${params.from} ~ ${params.to}`
                //     }
                //     let locationObj = this.options2.find(elem =>{
                //         return location == elem.value ;
                //     })
                //     if(locationObj){
                //         location = locationObj.label ;
                //     }else{
                //         location = ''
                //     }
                //     report.location = location;  
                //     report.amt = this.changeTree(Math.trunc(report.amt));
                //     report.ali = this.changeTree(Math.trunc(report.ali));
                //     report.cash = this.changeTree(Math.trunc(report.cash));
                //     report.credit = this.changeTree(Math.trunc(report.credit));
                //     report.qty = this.changeTree(Math.trunc(report.qty));
                //     report.unipay = this.changeTree(Math.trunc(report.unipay));
                //     report.wechat = this.changeTree(Math.trunc(report.wechat));
                //     this.tableData = [report];
                // }else{
                //     this.alert('查找失败!','warning')
                // }
               
            }).catch(() => {
                this.loading = false;
                this.alert('查找失败!','warning')
            })
        },

        //默认选择当前日期
        defaultNow(){
            let defaultVal = this.defaultVal ;
            defaultVal[0] = new Date() ;
            defaultVal[0] = defaultVal[0].getFullYear() + '-' + this.checkTime(defaultVal[0].getMonth() + 1) + '-' + this.checkTime(defaultVal[0].getDate()) ;
            defaultVal[1] = defaultVal[0] ;
            // console.log(defaultVal)
            this.ruleForm.date = defaultVal ;
        },

        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总计';
                    return;
                }
                if (index === 4) {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                // const values = data.map(item => Number(item[column.property].replace(/,/g, "")));
                if (!values.every(value => isNaN(value))) {
                    debugger
                    sums[index] = values.reduce((prev, curr) => {
                        
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0).toFixed(2);
                    sums[index] = this.changeTree(sums[index]);
                } else {
                    sums[index] = '';
                }
                });
               
                if(sums[3]!=''&&sums[3]!='undefined'){
                    debugger
                    console.log(sums[3])
                    //sums[3]=sums[3].toFixed(2)    
                }
                return sums;
        },

    }
}
</script>
